export const CATEGORIES = {
    food: { tw: '美食', cn: '美食', icon: '🍜' },
    sight: { tw: '景點', cn: '景点', icon: '🏔️' },
    shop: { tw: '購物', cn: '购物', icon: '🛍️' },
    stay: { tw: '住宿', cn: '住宿', icon: '🏨' },
    move: { tw: '交通', cn: '交通', icon: '🚆' },
    onsen: { tw: '溫泉', cn: '温泉', icon: '♨️' },
    coffee: { tw: '咖啡', cn: '咖啡', icon: '☕️' },
    bar: { tw: '酒吧', cn: '酒吧', icon: '🍶' },
    other: { tw: '其他', cn: '其他', icon: '📌' },
};
export const VOTE_LABELS = {
    love: { tw: '必去', cn: '必去', icon: '♥︎' },
    yes: { tw: '想去', cn: '想去', icon: '✓' },
    maybe: { tw: '還好', cn: '还好', icon: '〜' },
};
export const AVATAR_PALETTE = [
    '#E8955C', '#4F9E9C', '#D97A3A', '#3A8280',
    '#C86A6A', '#8A6CC1', '#4F9E7C', '#E0A94A',
];
export function fmtTime(min) {
    const h = Math.floor(min / 60);
    const m = min % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}
export function parseTime(s) {
    const m = s.match(/^(\d{1,2}):(\d{2})$/);
    if (!m)
        return null;
    const h = Number(m[1]);
    const mm = Number(m[2]);
    if (h < 0 || h > 23 || mm < 0 || mm > 59)
        return null;
    return h * 60 + mm;
}
export function fmtMoney(n, currency = 'TWD') {
    try {
        return new Intl.NumberFormat('zh-TW', { style: 'currency', currency, maximumFractionDigits: 0 }).format(n);
    }
    catch {
        return `${currency} ${n}`;
    }
}
export function relativeTime(iso, lang = 'tw') {
    const t = new Date(iso).getTime();
    if (isNaN(t))
        return '';
    const diff = (Date.now() - t) / 1000;
    const T = (tw, cn) => (lang === 'cn' ? cn : tw);
    if (diff < 60)
        return T('剛剛', '刚刚');
    if (diff < 3600)
        return `${Math.floor(diff / 60)} ${T('分鐘前', '分钟前')}`;
    if (diff < 86400)
        return `${Math.floor(diff / 3600)} ${T('小時前', '小时前')}`;
    if (diff < 86400 * 7)
        return `${Math.floor(diff / 86400)} ${T('天前', '天前')}`;
    return new Date(iso).toLocaleDateString(lang === 'cn' ? 'zh-CN' : 'zh-TW');
}
export function daysBetween(startIso, endIso) {
    if (!startIso || !endIso)
        return 0;
    const ms = new Date(endIso).getTime() - new Date(startIso).getTime();
    return Math.max(1, Math.round(ms / 86400000) + 1);
}
